(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Mobile vehicle strip: hide on scroll-down, reveal on scroll-up (header stays sticky).
  // Drive collapse with inline max-height (beats custom.css's fixed height:50px). Guard
  // against the feedback wobble: collapsing reflows the page + fires a scroll event, so
  // suppress the next couple events after a state change and only toggle past a threshold.
  (function () {
    var strip = document.querySelector('.cm-mobile-single-garage');
    if (!strip) return;
    strip.style.overflow = 'hidden';
    strip.style.transition = 'max-height 220ms cubic-bezier(0.16,1,0.3,1)';
    var hidden = false, last = window.scrollY, ticking = false, suppressUntil = 0;
    function apply(h) {
      if (h === hidden) return;
      hidden = h;
      strip.style.maxHeight = h ? '0px' : '64px';
      suppressUntil = performance.now() + 180;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var cur = window.scrollY;
        if (window.innerWidth >= 990) { apply(false); last = cur; return; }
        if (performance.now() < suppressUntil) { last = cur; return; }
        var delta = cur - last;
        if (delta > 8 && cur > 80) apply(true);
        else if (delta < -8) apply(false);
        last = cur;
      });
    }, { passive: true });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.tso-pdp__hero').forEach(function (hero) {
  var stage = hero.querySelector('.tso-pdp__stage-img');
  var thumbs = Array.prototype.slice.call(hero.querySelectorAll('.tso-pdp__thumb'));
  var marks = Array.prototype.slice.call(hero.querySelectorAll('.tso-gal-mark'));
  if (!stage || !thumbs.length) return;
  var idx = 0;
  function show(i) {
    idx = (i + thumbs.length) % thumbs.length;
    var btn = thumbs[idx];
    if (btn.dataset.src) { stage.srcset = ''; stage.src = btn.dataset.src; }
    thumbs.forEach(function (b, j) { b.classList.toggle('is-active', j === idx); });
    marks.forEach(function (m, j) {
      m.classList.toggle('is-active', j === idx);
      m.setAttribute('aria-selected', j === idx ? 'true' : 'false');
    });
  }
  thumbs.forEach(function (b, j) { b.addEventListener('click', function () { show(j); }); });
  marks.forEach(function (m, j) { m.addEventListener('click', function () { show(j); }); });
  hero.querySelectorAll('.tso-gal-arrow').forEach(function (a) {
    a.addEventListener('click', function () { show(idx + (a.dataset.dir === 'prev' ? -1 : 1)); });
  });
  // mobile swipe on the stage
  var stageWrap = hero.querySelector('.tso-pdp__stage');
  var swipeX = null;
  stageWrap.addEventListener('touchstart', function (e) { swipeX = e.touches[0].clientX; }, { passive: true });
  stageWrap.addEventListener('touchend', function (e) {
    if (swipeX === null) return;
    var dx = e.changedTouches[0].clientX - swipeX;
    swipeX = null;
    if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1));
  }, { passive: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tso-lp-hero"] && !Shopify.designMode) return;
  try {
    
  // Reveal the sticky CTA once the hero has scrolled out of view. No scroll
  // listener: the hero is the only thing being observed, and repositioning the
  // page on scroll is forbidden by the builder-shell rules this theme follows.
  (function () {
    var bar = document.querySelector('[data-tso-lp-sticky]');
    var hero = document.querySelector('[data-tso-lp-hero]');
    if (!bar || !hero || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(hero);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tso-lp-lead"] && !Shopify.designMode) return;
  try {
    
  // Sticky CTA appears once the lead scrolls out of view. Observer only — no
  // scroll listeners (builder-shell rules).
  (function () {
    var bar = document.querySelector('[data-tso-lp-sticky]');
    var lead = document.querySelector('[data-tso-lp-lead]');
    if (!bar || !lead || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(lead);
  })();

  } catch(e) { console.error(e); }
})();
})();
